var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestDevices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.385 4H4.615C4.275 4 4 4.311 4 4.696v11.13c0 .384.276.696.615.696h14.77c.34 0 .615-.312.615-.696V4.696C20 4.31 19.724 4 19.385 4zM10.77 16.521L9.537 20M13.23 16.521L14.463 20M8.308 20h7.384M15.077 10.261H8.923M12 6.783v6.956",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgRequestDevices;